// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"SocMeLinkGroup_iconContainer__EJV2_","icon":"SocMeLinkGroup_icon__RCv9F"};